import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateFilename',
    standalone: false
})
export class TruncateFilenamePipe implements PipeTransform {
    transform(value: string, length: number): string {
        if (value && length >= value.length) {
            return value;
        } else if (value) {
            let fileName = value.substring(0, Math.min(length, value.lastIndexOf('.')));
            let fileExtension = value.substring(value.lastIndexOf('.'), value.length);
            return fileName + '..' + fileExtension;
        }
        return '';
    }
}
